export const SET_JSD_WIDGET_READY = "SET_JSD_WIDGET_READY";
